import { LegacyRef, forwardRef } from 'react';

const TextInputField: React.FC<{
  label: string;
  placeholder: string;
  id: string;
  type: string;
  error?: string;
}> = forwardRef(({ label, placeholder, id, type, error, ...field }, ref) => (
  <div className="flex flex-col gap-2">
    <label
      className="typography-product-heading-compact-desktop text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary"
      htmlFor={id}
    >
      {label}
    </label>
    {type === 'text' || type === 'number' ? (
      <input
        id={id}
        placeholder={placeholder}
        className="text-color-text-lightmode-placeholder::placeholder dark:text-color-text-darkmode-placeholder::placeholder hide-number-stepper h-11 w-full rounded-md border-0 bg-color-bg-lightmode-secondary pl-3 pr-3 font-light text-color-text-lightmode-primary focus:outline-0 dark:bg-color-bg-darkmode-secondary dark:text-color-text-darkmode-primary"
        ref={ref as LegacyRef<HTMLInputElement>}
        type={type}
        {...field}
      />
    ) : (
      <textarea
        id={id}
        placeholder={placeholder}
        className="text-color-text-lightmode-placeholder::placeholder dark:text-color-text-darkmode-placeholder::placeholder hide-number-stepper h-20 w-full rounded-md border-0 bg-color-bg-lightmode-secondary px-3 font-light text-color-text-lightmode-primary focus:outline-0 dark:bg-color-bg-darkmode-secondary dark:text-color-text-darkmode-primary"
        ref={ref as LegacyRef<HTMLTextAreaElement>}
        {...field}
      />
    )}
    {error && <p className="text-sm text-red-500">{error}</p>}
  </div>
));

export default TextInputField;
